/**
 * @deprecated use the one exported from @sparelabs/core instead.
 */
export const delay = async (milliseconds: number) => new Promise<void>((resolve) => setTimeout(resolve, milliseconds))
